import axios from "axios";
import { baseUrl } from "./index";
//查询全部产品导航
export const getGWProductInfoList = (params) =>
  axios.get(baseUrl + "/getGWProductInfoList", { params });
// 根据ID查询产品
export const getGWProductInfoListById = (params) =>
    axios.get(baseUrl + "/getGWProductInfoListById", { params });
//根据ID查询产品详情
export const getGWProductDetailById = (params) =>
    axios.get(baseUrl + "/getGWProductDetailById", { params });
